// This file serves as a root to combine all custom middleware so they don't bloat the store.ts file size
import { logMessageMiddleware } from 'TutorBotChat';

export const customMiddleware = [logMessageMiddleware];

export default customMiddleware;
